import {DropdownItem, FormControl, FormField, openDropdown} from 'platform/components';
import {Grid, GridItem, Heading, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {
  GetArticleResponse,
  useGetDispensingUnitPresetsQuery,
  useGetHandlingUnitsQuery,
} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';
import {getActiveOptionsFromHandlingUnits} from '@dms/shared-aftersales';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {ArticleDetailForm} from '../types/ArticleDetailFormSchema';

interface GeneralInformationTabUnitsFormProps extends RequiredTestIdProps {
  formApi: UseFormReturn<ArticleDetailForm>;
  control: FormControl<ArticleDetailForm>;
  article: GetArticleResponse;
}

export function GeneralInformationTabUnitsForm(props: GeneralInformationTabUnitsFormProps) {
  const {data: handlingUnits} = useGetHandlingUnitsQuery();

  const {data: dispensingUnitPresets} = useGetDispensingUnitPresetsQuery();

  const [articleEdit] = usePermissions({
    permissionKeys: ['articleEdit'],
  });

  return (
    <>
      <VStack spacing={3}>
        <Heading size={4}>{i18n.t('entity.warehouse.labels.units')}</Heading>
        <Grid columns={4}>
          <GridItem span={1}>
            <FormField
              isRequired
              name="generalInformation.units.handlingUnit"
              type="choice"
              label={i18n.t('entity.warehouse.labels.measurementUnit')}
              control={props.control}
              options={getActiveOptionsFromHandlingUnits(handlingUnits)}
              isNotClearable
              data-testid={suffixTestId('inputs.handlingUnit', props)}
            />
          </GridItem>

          <GridItem span={1}>
            <FormField
              isRequired
              isDisabled={!articleEdit}
              control={props.control}
              name="generalInformation.units.dispensingUnit"
              type="number"
              tooltip={i18n.t('entity.warehouse.labels.dispensingUnitTooltip')}
              label={i18n.t('entity.warehouse.labels.dispensingUnit')}
              labelActions={
                dispensingUnitPresets
                  ? [
                      {
                        title: i18n.t('entity.warehouse.labels.presets'),
                        onClick: (e) =>
                          openDropdown(
                            e,
                            dispensingUnitPresets?.map((preset) => (
                              <DropdownItem
                                key={preset.id}
                                label={preset.value.toString()}
                                onClick={() =>
                                  props.formApi.setValue(
                                    'generalInformation.units.dispensingUnit',
                                    preset.value
                                  )
                                }
                              />
                            ))
                          ),
                      },
                    ]
                  : undefined
              }
              decimalPlaces={4}
            />
          </GridItem>
        </Grid>
      </VStack>
    </>
  );
}
